import styled, { css } from "styled-components";
import { TextArea as TextAreaPrimitive } from "react-aria-components";
import { CoreTypography } from "@boi/components-core";
import { useDesignTokens, parseSizeToken } from "@boi/react-design-tokens";

type TextAreaProps = {
  $autoGrow?: boolean;
  $maxHeight?: number;
};

export const TextArea = styled(TextAreaPrimitive)<TextAreaProps>`
  ${({ $autoGrow, $maxHeight }) => {
    const { tokens } = useDesignTokens();
    const { textArea, typography, scrollBar } = tokens;

    const typographyVariant: CoreTypography.Variant =
      textArea.typography.variant;

    const fontSize = parseSizeToken(typography.fontSize[typographyVariant]);
    const lineHeight = parseSizeToken(typography.lineHeight[typographyVariant]);

    return [
      css`
        all: unset;
        min-height: ${textArea.minHeight};
        padding: calc(${textArea.paddingVertical} - 2px)
          calc(${textArea.paddingHorizontal} - 2px);
        margin: 2px;
        color: ${textArea.color.base};
        font-family: ${typography.fontFamily[typographyVariant]};
        font-size: ${fontSize};
        line-height: ${lineHeight};
        scrollbar-color: ${scrollBar.thumbColor} transparent;

        &[data-readonly] {
          color: ${textArea.color.readOnly};
        }

        &[data-disabled] {
          color: ${textArea.color.disabled};
        }

        &::placeholder {
          color: ${textArea.color.placeholder};
        }
      `,
      $maxHeight &&
        css`
          max-height: ${$maxHeight}px;
        `,
      $autoGrow &&
        css`
          field-sizing: content;
        `,
    ];
  }}
`;

export const CharactersCounterContainer = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { spacing } = tokens;

    return css`
      width: 100%;
      display: grid;
      gap: ${spacing.s4};
    `;
  }}
`;
